var useAlertStyles = function useAlertStyles(_ref) {
  var variant = _ref.variant;

  switch (variant) {
    case 'success':
      return {
        icon: 'check-circle',
        backgroundColor: 'green-400'
      };

    case 'info':
      return {
        icon: 'info',
        backgroundColor: 'blue-400'
      };

    case 'warning':
      return {
        icon: 'alert-circle',
        backgroundColor: 'orange-400'
      };

    case 'error':
      return {
        icon: 'alert-circle',
        backgroundColor: 'pink-700'
      };

    case 'default':
    default:
      return {
        icon: 'info',
        backgroundColor: 'navyblue-300'
      };
  }
};

export default useAlertStyles;